function BottomNavIcons({ nav, color }) {
    const findIcon = () => {
        switch (nav) {
            case 'home':
                return [
                    'M12.3315 0L22.75 9.65135L21.5869 10.8328L19.9324 9.30856V20.168L19.1134 21H14.199L13.3799 20.168V14.3439H10.1037V20.168L9.28462 21H4.37025L3.55119 20.168V9.32187L1.91307 10.8328L0.75 9.65135L11.1521 0H12.3315ZM5.18931 7.80927V19.336H8.46556V13.5119L9.28462 12.6799H14.199L15.0181 13.5119V19.336H18.2943V7.79929L11.7418 1.76387L5.18931 7.80927Z'
                ]
            case 'class':
                return [
                    'M18.2259 23.6805C17.7999 24.1065 17.1092 24.1065 16.6832 23.6805L12 18.9973L7.31684 23.6805C6.89082 24.1065 6.20009 24.1065 5.77406 23.6805C5.34804 23.2545 5.34804 22.5637 5.77406 22.1377L9.36631 18.5455H3.27273C1.46525 18.5455 0 17.0802 0 15.2727V3.27273C0 1.46525 1.46525 0 3.27273 0H20.7273C22.5348 0 24 1.46525 24 3.27273V15.2727C24 17.0802 22.5348 18.5455 20.7273 18.5455H14.6337L18.2259 22.1377C18.652 22.5637 18.652 23.2545 18.2259 23.6805ZM20.7273 16.3636C21.3298 16.3636 21.8182 15.8752 21.8182 15.2727V3.27273C21.8182 2.67024 21.3298 2.18182 20.7273 2.18182H3.27273C2.67023 2.18182 2.18182 2.67024 2.18182 3.27273V15.2727C2.18182 15.8752 2.67023 16.3636 3.27273 16.3636H20.7273Z',
                    'M8.76314 6.48205C8.76314 5.71225 9.59647 5.23113 10.2631 5.61603L15.5131 8.64711C16.1798 9.03201 16.1798 9.99426 15.5131 10.3792L10.2631 13.4103C9.59647 13.7952 8.76314 13.314 8.76314 12.5442V6.48205Z'
                ]
            case 'exam':
                return [
                    'M0.87868 0.87868C1.44129 0.31607 2.20435 0 3 0H11C11.2652 0 11.5196 0.105357 11.7071 0.292893L17.7071 6.29289C17.8946 6.48043 18 6.73478 18 7V19C18 19.7957 17.6839 20.5587 17.1213 21.1213C16.5587 21.6839 15.7957 22 15 22H3C2.20435 22 1.44129 21.6839 0.87868 21.1213C0.31607 20.5587 0 19.7957 0 19V3C0 2.20435 0.31607 1.44129 0.87868 0.87868ZM3 2C2.73478 2 2.48043 2.10536 2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3V19C2 19.2652 2.10536 19.5196 2.29289 19.7071C2.48043 19.8946 2.73478 20 3 20H15C15.2652 20 15.5196 19.8946 15.7071 19.7071C15.8946 19.5196 16 19.2652 16 19V8H11C10.4477 8 10 7.55228 10 7V2H3ZM12 3.41421L14.5858 6H12V3.41421ZM4 8C4 7.44772 4.44772 7 5 7H7C7.55228 7 8 7.44772 8 8C8 8.55228 7.55228 9 7 9H5C4.44772 9 4 8.55228 4 8ZM4 12C4 11.4477 4.44772 11 5 11H13C13.5523 11 14 11.4477 14 12C14 12.5523 13.5523 13 13 13H5C4.44772 13 4 12.5523 4 12ZM4 16C4 15.4477 4.44772 15 5 15H13C13.5523 15 14 15.4477 14 16C14 16.5523 13.5523 17 13 17H5C4.44772 17 4 16.5523 4 16Z'
                ]
        }
    }

    return (
        <svg
            width="23"
            height="21"
            viewBox="0 0 23 21"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            {!!findIcon().length &&
                findIcon().map((el, key) => (
                    <path
                        key={key}
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d={el}
                        fill={color}
                    />
                ))}
        </svg>
    )
}

export default BottomNavIcons
